import { render, staticRenderFns } from "./ImageShape.vue?vue&type=template&id=34f1b3cf"
import script from "./ImageShape.vue?vue&type=script&lang=ts"
export * from "./ImageShape.vue?vue&type=script&lang=ts"
import style0 from "./ImageShape.vue?vue&type=style&index=0&id=34f1b3cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports